import { routeData } from "@/router/constants/routes";
import router from "@/router";

export async function paymentMethodBeforeEnter(to, from) {
    // Refresh page when navigating back from payment to avoid iframe issues.
    if (from.name === routeData.PAYMENT.name) {
        router.go(0);
    }
}
